module.exports = __webpack_public_path__ + "img/title.d909f4fd.png";